export enum EnumTipoCPrecio {
  Final = 1,
  Resumen,
  Auxiliar
}
